import { ActionType } from '../../types/action';

const listPermission = {
  resource: 'user-fee-deductions',
  action: ActionType.READ,
};

const statusUpdatePermission = {
  resource: 'user-fee-deduction-status',
  action: ActionType.UPDATE,
};

export const UserFeeDeduction = {
  list: listPermission,
  statusUpdate: statusUpdatePermission,
};
